import { Component,  OnInit,Input } from '@angular/core';
import { UserService } from './Services/user.service';
import { User } from './Models/user';
import { Utility } from './Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { HeaderService } from './Services/header.service';
import { NavigationStart, Router } from '@angular/router';




declare var $: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [{
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: { color: 'primary' },
}]
})
export class AppComponent  implements OnInit {

userMenu:any;
Header:any;
utility:Utility;


  constructor(private _UserService: UserService, public cookieService: CookieService,private HeaderService: HeaderService,  private router: Router) { 
    this.utility = new Utility(this.cookieService);
    
    HeaderService.changeEmitted$.subscribe(data => { //Added By rahul yadav on 5/04/2021 To pass data to app component using header service to hide header menu
      this.Header=data;
    });
  }

  ngOnInit(): void {  
    this.router.events
          .subscribe(
            (event: any) => {
              if(event instanceof NavigationStart) {
              let ActiveRoute:string = event.url.split('?')[0].substring(1);
              //check for session page when user log in first time  
              if(ActiveRoute != 'session'){
                //Extend cookie time 
                this.utility.ExtendSessionTime();
              }
              }
            });
 
    $(".hor-menu").hide();
    this._UserService.GetUserMenu(this.utility.user.employeeId).toPromise().then((d) => {
      this.userMenu = d;
      setTimeout(() => {
      $(".hor-menu").attr("class","main");
      $(".navbar-nav").attr("class","mainnav");
      $(".dropdown-submenu ul[class='dropdown-menu']").attr("class","dropdown");
      $("li[class=' ']").attr("class","subs");
      $(".dropdown-submenu").attr("class","subs hassubs");
      $(".dropdown-menu").attr("class","dropdown");
      $(".menu-dropdown").attr("class","hassubs");
      $(".main").show()
      
      //this.Header=0
    }, 100);
    }).catch((e) => {
      // window.location.href = "https://localhost:8083";      
    });

    }

  


  LogOut(){    
    this.utility.ClearAllCookies();
    this.utility.LogOutErp();
  }

}
